const bookingMenu = {
  id: "booking",
  title: "Booking",
  type: "group",
  icon: "heroicons-outline:calendar-days",
  children: [
    {
      id: "booking.dashboard",
      title: "Dashboard",
      type: "item",
      icon: "heroicons-outline:home",
      url: "/dashboard",
    },
    {
      id: "booking.appointments",
      title: "Appointments",
      type: "collapse",
      icon: "heroicons-outline:calendar",
      children: [
        {
          id: "booking.calendar",
          title: "Calendar",
          type: "item",
          url: "/appointments",
        },
        {
          id: "booking.list",
          title: "List of booking",
          type: "item",
          url: "/listofbooking",
        },
        {
          id: "booking.walkin",
          title: "Create Walk in",
          type: "item",
          url: "/apps/booking/walkin",
        },
      ],
    },
    {
      id: "booking.staffs",
      title: "Staffs",
      type: "collapse",
      icon: "heroicons-outline:user-group",
      children: [
        {
          id: "booking.staffs.list",
          title: "List of Staffs",
          type: "item",
          url: "/staffs",
        },
        {
          id: "booking.staffs.create",
          title: "Create new staff",
          type: "item",
          url: "/staff/create",
        },
      ],
    },
    {
      id: "booking.customers",
      title: "Customers",
      type: "item",
      icon: "heroicons-outline:headset",
      url: "/apps/customers",
    },
    {
      id: "booking.services",
      title: "Services",
      type: "collapse",
      icon: "heroicons-outline:archive-box",
      children: [
        {
          id: "booking.services",
          title: "Services",
          type: "item",
          url: "/bookingservices",
        },
        {
          id: "booking.services.beauty",
          title: "Beauty Services",
          type: "item",
          url: "/apps/services/beauty",
        },
      ],
    },
    {
      id: "booking.settings",
      title: "Settings",
      type: "item",
      icon: "heroicons-outline:cog-6-tooth",
      url: "/apps/settings",
    },
  ],
};

export default bookingMenu;
